import { ref } from 'vue';

export default {
    name: 'Tooltip',
    props: {
      last: {
        type: Boolean,
        default: false
      },
      text: {
          type: String, 
          required: true,
      },
      hideTooltip: {
        type: Boolean,
        default: false,
      }
    },
    setup() {
        let showTooltip = ref(false);
        return {
            showTooltip,
        }
    },
    computed: {
        getClassName() {
            if(this.hideTooltip) {
                return;
            }
            if(this.showTooltip) {
                if(this.last) {
                    return 'koc-tooltip-last-active-top'    
                } 
                return 'koc-tooltip-active-top'
            }                                 
        }
    }
};